<template>
  <v-dialog
    v-model="dialog"
    max-width="1000px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Adjusted Days History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="entitlement.employee.person.name"
      :text="entitlement.leave_type.name"
      class="mb-0"
      max-height="600px"
    > 
      <template v-if="!loading">
        <v-container>
          <v-data-table
            :headers="headers"
            :items="leaveEntitlementAdjustments"
            item-value="id"
            fixed-header
            class="overflow"
          >
            <template v-slot:item.created_at="{ item }">
              {{ $moment(item.created_at).format('YYYY-MM-DD') }}
            </template>
            <template v-slot:item.adjusted_days="{ item }">
              {{ item.adjusted_days ? item.adjusted_days.toFixed(2) : item.adjusted_days }}
            </template>
            <template v-slot:item.remarks="{ item }">
              <div v-html="item.remarks" />
            </template>
            <template v-slot:item.documents="{ item }">
              <div v-if="item.documents && item.documents.length > 0">
                <v-col
                  v-for="document in item.documents"
                  :key="document.id"
                  cols="12"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-chip
                        color="blue-grey lighten-3"
                        link
                        style="min-width: 100px;"
                        :href="document.file_url"
                        target="_blank"
                        v-on="{ ...tooltip }"
                      >
                        <v-icon
                          color="red"
                          left
                        >
                          mdi-file-pdf
                        </v-icon>
                        <span>{{ document.file_name }}</span>
                      </v-chip>
                    </template>
                    <span>{{ document.file_name }}</span>
                  </v-tooltip>
                </v-col>
              </div>
              <div v-else>
                0 document
              </div>
            </template>
          </v-data-table>
        </v-container>
      </template>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      entitlement: {
        type: Object,
        default: null,
      },    
    },
    data () {
      return {
        dialog: false,
        loading: false,
        leaveEntitlementAdjustments: [],
        headers: [
          {
            text: 'Date',
            align: 'left',
            value: 'created_at',
            width: '15%',
          },
          {
            text: 'Adjusted Days',
            align: 'center',
            value: 'adjusted_days',
            width: '20%',
          },
          {
            text: 'Remarks',
            align: 'left',
            value: 'remarks',
            width: '40%',
          },
          {
            text: 'Document',
            align: 'left',
            value: 'documents',
            width: '25%',
          },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadData()
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.leaveEntitlementAdjustments().show(this.entitlement.id)
          .then(res => {
            this.leaveEntitlementAdjustments = res.data
          })
          .catch(e => {})
          .then(res => {
            this.loading = false
          })
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    max-height:460px;
    overflow: auto;
  }
</style>
